<template>
	<modal-box @close="close" :header="$t('headers.general.attach_device')" :subHeader="`${$t('headers.general.patient')} > ${$t('headers.general.options')}`" class="watch-options-form-attach-device">
		<form @submit.prevent="validateAndSubmit">
			<input-select v-model="model.device_id" :options="deviceOptions" name="device" :placeholder="$t('labels.general.device')" rules="required"/>
			<error-box v-if="form.error" :error="form.error"/>
			<div class="form-group-actions">
				<button-submit-icon-text :loading="form.loading" icon="check">{{ $t('buttons.general.add') }}</button-submit-icon-text>
			</div>
		</form>
	</modal-box>
</template>

<script>
import FormObject from '@/classes/api/FormObject'
import ApiCollection from '@/classes/api/ApiCollection'
import DeviceCollection from '@/classes/DeviceCollection'
export default {
	props: [
		'user_uid',
		'watch_id'
	],
	data () {
		return {
			name: 'watch options attach device form',
			model: {
				device_id: ''
			},
			form: new FormObject(),
			devices: new ApiCollection(),
			deviceOptions: []
		}
	},
	methods: {
		validateAndSubmit () {
			this.$validator.validateAll()
				.then(result => {
					if (result) this.submit()
				})
		},
		submit () {
			this.attachDevice()
		},
		close (reload = false) {
			this.$emit('close', { reload })
		},
		getDevices () {
			this.devices.loading = true
			this.$api.devices.getAllAvailable(this, this.user_uid)
				.then(response => {
					this.$log.info(this.name, 'devices.getAll OK', response)()
					this.devices.data = new DeviceCollection(response.body)
					this.deviceOptions = this.devices.toSelectOptions()
				}).catch(error => {
					this.$log.error(this.name, 'devices.getAll ERROR', error)()
					this.devices.error = error
				}).finally(() => {
					this.devices.loading = false
				})
		},
		attachDevice () {
			this.loading = true
			this.$api.patients.devices.attach(this, this.user_uid, this.watch_id, this.model)
				.then(response => {
					this.$log.info(this.name, 'patients.devices.attach OK', response)()
					this.close(true)
				}).catch(error => {
					this.$log.error(this.name, 'patients.devices.attach ERROR', error)()
					this.form.error = error
				}).finally(() => {
					this.loading = false
				})
		}
	},
	created () {
		this.getDevices()
	}
}
</script>



// WEBPACK FOOTER //
// src/components/watch/options/WatchOptionsFormAttachDevice.vue